import { render, staticRenderFns } from "./PaymentAlertDialog.vue?vue&type=template&id=28bc6d54&"
import script from "./PaymentAlertDialog.vue?vue&type=script&lang=js&"
export * from "./PaymentAlertDialog.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAlertDialog.vue?vue&type=style&index=0&id=28bc6d54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports